export default {
  postLogout(options) {
    return this.http('APPInterface', 'post', 'v1/account/cancellations', options);
  }
};
